// extracted by mini-css-extract-plugin
export default {"main":"FormBox_main__crQFK","nameContainer":"FormBox_nameContainer__UFB1v","name":"FormBox_name__Xy92U"};